import React, { useMemo } from 'react';
import { Text as SlateText, Descendant } from 'slate';
import { devLog } from '@/utils';
import style from './index.module.css';
import { ImageComponent } from '../../ElementComponents/ImageComponent';
import { LinkComponent } from '../../ElementComponents/LinkComponent';
const log = (...info: any) => {
  devLog('RichTextPreview', ...info);
};

const serializeHTMLElement = (node: any, key?: number) => {
  if (SlateText.isText(node)) {
    return (
      <span className={style.textNode} key={`span-${key}`}>
        {node.text}
      </span>
    );
  }

  const children: Descendant[] = node.children?.map((n: Descendant, index: number) =>
    serializeHTMLElement(n, index),
  );

  switch (node.type) {
    case 'paragraph':
      return (
        <div className={style.paragraph} key={`p-${key}`}>
          {children}
        </div>
      );
    case 'link':
      return LinkComponent({ attributes: {}, element: node, children, readOnly: true });
    case 'image':
      return ImageComponent({ attributes: {}, element: node });
    default:
      return children;
  }
};

export const RichTextPreviewer = (props: { content: string | null }) => {
  const { content } = props;

  const PreviewComponent = useMemo(() => {
    log('rawContent -->', content);
    const RichTextContent = content
      ? serializeHTMLElement({ children: JSON.parse(content) })
      : null;
    log('rn component -->', RichTextContent);
    return <div className={style.richTextPreviewerWrapper}>{RichTextContent}</div>;
  }, [content]);

  return PreviewComponent;
};
